import React, { useEffect, useMemo, useState } from "react"
import Card from "components/Card/Card"
import { Box, CircularProgress, Grid, List, ListItem, Typography } from "@mui/material"
import { useTheme } from "@mui/system"
import { useDispatch, useSelector } from "react-redux"
import { marketingActions } from "redux/marketing/slice/user"
import { useHistory } from "react-router-dom"
import { getDynamicMenuFieldsAction } from "redux/superAdmin/actions"
import { getUploadStatusAction, uploadMenuForReviewAction } from "redux/marketing/actions"
import image from "assets/images/imagePlaceholder.png"
import MenuImageDisplayer from "components/Menu"
import AppButton from "components/StyledComponents/AppButton"
import CommonModal from "components/CommonModal"
import CommonDragAndDrop from "components/CommonDragAndDrop"
import AppSelect from "components/StyledComponents/AppSelect"
import { menuUploadType } from "helpers/constant"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"

function MenuSnapShot({ path = "/marketing/dashboard/explore-menu", subCategory }) {
  const theme = useTheme()
  const dispatch = useDispatch()
  const history = useHistory()
  const { menuImageList } = useSelector((store) => store.superAdmin)
  const { menuUploadStatus, uploadProgress, isMenuUploading } = useSelector(
    (store) => store.marketing.menu
  )
  const { isLoading } = useSelector((store) => store.app)
  const [menuSnapshotData, setMenuSnapshotData] = useState([])
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [isUploadEnabled, setIsUploadEnabled] = useState(false)
  const mediaMatch = window.matchMedia("(max-width: 2000px) and (min-width: 1700px)")
  const [selectedDocType, setSelectedDocType] = useState("pdf")
  const noop = () => {}
  const classes = {
    featureItemContainer: {
      border: `1px solid `,
      borderColor: theme.palette.secondary.main,
      display: "flex",
      position: "relative",
      margin: 16,
      borderRadius: 12,
      height: 120,
      cursor: "pointer"
    },
    wineMonth: {
      textTransform: "uppercase",
      color: theme.palette.secondary.main
    },
    wineBottle: {
      height: "100%",
      width: `${mediaMatch.matches ? "calc(100% - 120px)" : "calc(100% - 80px)"}`
    },
    wineImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderTopLeftRadius: 12,
      borderBottomLeftRadius: 12
    },
    wineDetail: {
      padding: 16,
      display: "flex",
      alignItems: "end"
    }
  }

  function handleMenuItem(items, name) {
    const linkItem = {
      item: items,
      category: subCategory || "",
      list: "Summary View"
    }
    dispatch(marketingActions.setMenuLink(linkItem))
    history.push(path)
    dispatch(getDynamicMenuFieldsAction({ category: name }))
  }

  const handleModalClose = () => {
    setIsUploadModalOpen(false)
    setSelectedFile(null)
    setIsUploadEnabled(false)
    setSelectedDocType("pdf")
    dispatch(marketingActions.setMenuUploadStatus(""))
  }

  const handleUploadMenuClick = () => {
    dispatch(getUploadStatusAction())
    setIsUploadModalOpen(true)
  }

  const handleUploadSubmit = () => {
    if (!selectedFile) {
      return
    }
    let formData = new FormData()
    formData.append("media", selectedFile)
    formData.append("media_type", "IMAGE")
    formData.append("content_type", "OTHER")
    dispatch(
      uploadMenuForReviewAction({
        file: formData,
        file_type: selectedDocType,
        onClose: handleModalClose
      })
    )
  }

  const isSubmitDisabled = useMemo(() => {
    return !isUploadEnabled
  }, [isUploadEnabled])

  useEffect(() => {
    if (selectedFile) {
      setIsUploadEnabled(true)
    } else {
      setIsUploadEnabled(false)
    }
  }, [selectedFile])
  useEffect(() => {
    const newDate = menuImageList.slice(0, 4).map((item) => {
      return {
        image: item.icon,
        name: item.name,
        link: "/marketing/dashboard/explore-menu",
        value: item.name.toLowerCase()
      }
    })

    setMenuSnapshotData(newDate)
  }, [menuImageList])

  return (
    <>
      <Card style={{ paddingBottom: 12 }}>
        <List>
          <ListItem sx={{ justifyContent: "space-between", padding: "0 0 12px 0" }}>
            <Typography variant="h2">Menu</Typography>
            <AppButton
              styles={{ padding: "10px 20px" }}
              onClick={handleUploadMenuClick}
              disabled={isMenuUploading}>
              {isMenuUploading ? (
                <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />
              ) : null}
              Upload Menu
            </AppButton>
          </ListItem>
        </List>
        {menuSnapshotData?.length ? (
          <Grid
            spacing={{ xs: 2, md: 3, lg: 4 }}
            container
            style={classes.mainContainer}
            className="p-4 ">
            {menuSnapshotData?.map((items, idx) => {
              return (
                <Grid key={idx} item xs={12} sm={12} md={4} lg={3} xl={3} className="p-0">
                  <div
                    style={classes.featureItemContainer}
                    onClick={() => handleMenuItem(items?.value, items?.name)}>
                    <div style={classes.wineBottle}>
                      {items?.image !== null ? (
                        <MenuImageDisplayer image={items?.image} />
                      ) : (
                        <img src={image} style={classes.wineImage} />
                      )}
                    </div>
                    <div style={classes.wineDetail}>
                      <div style={classes.nameWine}>
                        <Typography variant="caption2" style={classes.wineMonth}>
                          {items?.name}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </Grid>
              )
            })}
          </Grid>
        ) : (
          <Typography variant="caption2" style={{ opacity: 0.6 }}>
            {isLoading ? "Please wait, we are fetching the menu categories..." : "No data Found"}
          </Typography>
        )}
        <CommonModal
          open={isUploadModalOpen}
          onClose={handleModalClose}
          hideAction={!selectedFile}
          actionButtons={
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
              <AppButton variant="outlined" onClick={handleModalClose}>
                Cancel
              </AppButton>
              {menuUploadStatus === "COMPLETED" ||
              menuUploadStatus === "not found" ||
              menuUploadStatus === "FAILED" ? (
                <AppButton onClick={handleUploadSubmit} disabled={isSubmitDisabled}>
                  Upload
                </AppButton>
              ) : null}
            </Box>
          }
          maxWidth="sm">
          <Box sx={{ padding: { xs: 3, md: 4 } }}>
            <Typography variant="h2" textAlign="center">
              {menuUploadStatus === "COMPLETED" ? "Upload Menu" : "Upload Status"}
            </Typography>
            <Box sx={{ mt: 4 }}>
              {menuUploadStatus === "COMPLETED" ||
              menuUploadStatus === "not found" ||
              menuUploadStatus === "FAILED" ? (
                <>
                  <Box sx={{ mb: 2 }}>
                    <AppSelect
                      label="Document Type"
                      value={selectedDocType}
                      onChange={(e) => {
                        setSelectedDocType(e.target.value)
                        setSelectedFile(null)
                        setIsUploadEnabled(false)
                      }}
                      menuItems={menuUploadType}
                    />
                  </Box>
                  <CommonDragAndDrop
                    accept={
                      selectedDocType === "pdf"
                        ? ".pdf"
                        : selectedDocType === "docx"
                        ? ".doc,.docx"
                        : ".csv"
                    }
                    type={selectedDocType.toUpperCase()}
                    setDisable={setIsUploadEnabled}
                    setAllFilesSelected={noop}
                    onChange={(file) => setSelectedFile(file)}
                    preview={true}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                    py: 2
                  }}>
                  {uploadProgress?.error ? (
                    <ErrorOutlineIcon sx={{ fontSize: 48, color: "error.main" }} />
                  ) : (
                    <CircularProgress size={48} color="secondary" />
                  )}
                  <Typography
                    variant="body1"
                    textAlign="center"
                    sx={{ textTransform: "capitalize" }}
                    color={theme.palette.text.secondary}>
                    {uploadProgress?.status ?? "Processing..."}
                  </Typography>
                  {uploadProgress?.stage && (
                    <Typography
                      variant="caption"
                      textAlign="center"
                      color={theme.palette.text.secondary}>
                      {uploadProgress.stage}
                    </Typography>
                  )}
                  {uploadProgress?.error && (
                    <Typography variant="body2" textAlign="center" color="error.main">
                      {uploadProgress.error}
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </CommonModal>
      </Card>
    </>
  )
}

export default MenuSnapShot
